export const UPDATE_ONBOARDING_STEP = 'UPDATE_ONBOARDING_STEP';
export const UPDATE_ONBOARDING_STEP_SUCCESS = 'UPDATE_ONBOARDING_STEP_SUCCES';
export const UPDATE_ONBOARDING_STEP_ERROR = 'UPDATE_ONBOARDING_STEP_ERROR';
